import { Search } from "lucide-react";
import { Input } from "@/components/ui/input";
import { Button } from "@/components/ui/button";
import { Slider } from "@/components/ui/slider";
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "@/components/ui/select";

const SUBJECTS = ["All", "French", "English", "Spanish", "Math"];
const LEVELS = ["All", "Beginner", "Intermediate", "Advanced", "AP/College"];

export default function TutorFilters({ filters, onChange }) {
  const update = (patch) => onChange({ ...filters, ...patch });

  return (
    <div className="rounded-2xl border border-border/70 bg-card p-5 space-y-5" data-testid="tutor-filters">
      <div className="flex flex-wrap gap-1.5">
        {SUBJECTS.map((s) => (
          <Button
            key={s}
            variant={filters.subject === s ? "default" : "outline"}
            size="sm"
            onClick={() => update({ subject: s })}
            className="rounded-full text-xs sm:text-sm h-8 sm:h-9 px-3 sm:px-4"
            data-testid={`subject-filter-${s.toLowerCase()}`}
          >
            {s}
          </Button>
        ))}
      </div>

      <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
        <div className="relative md:col-span-1">
          <Search className="absolute left-3 top-1/2 -translate-y-1/2 h-4 w-4 text-muted-foreground" />
          <Input
            placeholder="Search tutors…"
            value={filters.q || ""}
            onChange={(e) => update({ q: e.target.value })}
            className="pl-9 rounded-full"
            data-testid="tutor-search-input"
          />
        </div>

        <Select value={filters.level || "All"} onValueChange={(v) => update({ level: v })}>
          <SelectTrigger className="rounded-full" data-testid="level-filter-select">
            <SelectValue placeholder="Level" />
          </SelectTrigger>
          <SelectContent>
            {LEVELS.map((l) => (
              <SelectItem key={l} value={l}>
                {l === "All" ? "All levels" : l}
              </SelectItem>
            ))}
          </SelectContent>
        </Select>

        <Select value={filters.sort || "rating"} onValueChange={(v) => update({ sort: v })}>
          <SelectTrigger className="rounded-full" data-testid="sort-select">
            <SelectValue placeholder="Sort" />
          </SelectTrigger>
          <SelectContent>
            <SelectItem value="rating">Highest rated</SelectItem>
            <SelectItem value="price_low">Price: low to high</SelectItem>
            <SelectItem value="price_high">Price: high to low</SelectItem>
          </SelectContent>
        </Select>
      </div>

      <div>
        <div className="flex items-center justify-between text-sm mb-2">
          <span className="font-medium">Hourly rate</span>
          <span className="text-muted-foreground">
            ${filters.priceRange?.[0] ?? 15} – ${filters.priceRange?.[1] ?? 120}
          </span>
        </div>
        <Slider
          min={15}
          max={120}
          step={5}
          value={filters.priceRange || [15, 120]}
          onValueChange={(v) => update({ priceRange: v })}
          data-testid="price-range-slider"
        />
      </div>
    </div>
  );
}
